import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const discountedPriceWithCodeSelector = createSelector(testTargetOffersSelector, offers => offers.discountedPriceWithCode || Empty.Object);

export { discountedPriceWithCodeSelector };
